import React, { FC } from 'react';
import { Grid } from '@mui/material';
import ActionButton from '../../../../components/buttons';

import { getStyles } from '../styles';

interface IProps {
  handleClose: () => void;
  onSubmit?: () => void;
  label: string;
  loading?: boolean;
}

const styles = getStyles();

const ActionButtons: FC<IProps> = ({ handleClose, onSubmit, label, loading = false }) => {
  const submitProps = onSubmit
    ? { type: 'button' as const, onClick: onSubmit }
    : { type: 'submit' as const };

  return (
    <Grid sx={styles.actions}>
      <ActionButton
        variant="outlined"
        type="button"
        label="cancel"
        className="btn"
        onClick={handleClose}
      />
      <ActionButton label={label} className="btn filled-btn" loading={loading} {...submitProps} />
    </Grid>
  );
};

export default ActionButtons;
